import { Api } from 'protokol-sdk'

export default {
    factorSDK(adapter) {
        let platformClient = new Api.Platform
        platformClient.setClient(adapter.getPlatformClient())

        return platformClient
    }
}